var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.905 4.815C16.8159 4.45906 16.6345 4.13293 16.379 3.86955C16.1235 3.60618 15.8031 3.41489 15.45 3.315C14.16 3 9 3 9 3C9 3 3.84 3 2.55 3.345C2.19694 3.44489 1.87648 3.63618 1.62101 3.89955C1.36554 4.16293 1.18409 4.48906 1.095 4.845C0.858912 6.15417 0.743428 7.48223 0.750001 8.8125C0.741586 10.1528 0.857077 11.491 1.095 12.81C1.19322 13.1549 1.37873 13.4686 1.63361 13.7209C1.88849 13.9731 2.20412 14.1554 2.55 14.25C3.84 14.595 9 14.595 9 14.595C9 14.595 14.16 14.595 15.45 14.25C15.8031 14.1501 16.1235 13.9588 16.379 13.6954C16.6345 13.4321 16.8159 13.1059 16.905 12.75C17.1393 11.4507 17.2547 10.1328 17.25 8.8125C17.2584 7.47222 17.1429 6.13402 16.905 4.815V4.815Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 11.2651L11.625 8.81261L7.3125 6.36011V11.2651Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.39714413dc38c9816477c49915c0d1da.svg";
export { ForwardRef as ReactComponent };